import { forwardRef } from 'react'
import { IconElement, IconProps } from 'types/ui'

export const FacebookLogo: IconElement = forwardRef(function FacebookLogo(
  { fill = 'currentColor', ...props }: IconProps,
  ref
) {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      ref={ref}
      {...props}
    >
      <g clipPath='url(#clip0_974_8111)'>
        <path
          d='M14.4 0H3.6C1.61496 0 0 1.61496 0 3.6V14.4C0 16.385 1.61496 18 3.6 18H14.4C16.385 18 18 16.385 18 14.4V3.6C18 1.61496 16.385 0 14.4 0ZM14.04 6.12H12.96C12.1878 6.12 11.88 6.30144 11.88 6.84V7.92H14.04L13.68 10.08H11.88V17.28H9.36V10.08H8.28V7.92H9.36V6.84C9.36 5.15628 9.92916 3.96 11.88 3.96C12.9247 3.96 14.04 4.32 14.04 4.32V6.12Z'
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id='clip0_974_8111'>
          <rect width='18' height='18' fill={fill} />
        </clipPath>
      </defs>
    </svg>
  )
})
